import { render, staticRenderFns } from "./forgotPass.vue?vue&type=template&id=5c144da4&"
import script from "./forgotPass.vue?vue&type=script&lang=js&"
export * from "./forgotPass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports